import { render, staticRenderFns } from "./AbnormalRecords.vue?vue&type=template&id=52dd325d&scoped=true&"
import script from "./AbnormalRecords.vue?vue&type=script&lang=js&"
export * from "./AbnormalRecords.vue?vue&type=script&lang=js&"
import style0 from "./AbnormalRecords.vue?vue&type=style&index=0&id=52dd325d&lang=scss&scoped=true&"
import style1 from "./AbnormalRecords.vue?vue&type=style&index=1&id=52dd325d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dd325d",
  null
  
)

export default component.exports